import {fromJS, Map} from 'immutable';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import gamesActions from '../actions/fortnite-game/games.actions';

export interface DataItem {
    day: string;
    creativeAccountId: string;
    creativeIslandCode: string;
    title: string;
    trend?: number;
}

export interface CodeNamesMap {
    [key: string]: string;
}

export interface GamesData {
    all: DataItem[];
    recent: DataItem[];
    popular: DataItem[];
    top10: DataItem[];
    top10Trending: DataItem[];
    codeNamesMap: CodeNamesMap;
}

export interface GamesState {
    data: GamesData;
    error?: string;
    loading: boolean;
}

const createMappings = (games: DataItem[]): {[key: string]: string} => {
    return games.reduce((acc, {creativeIslandCode, day, title}) => {
        acc[creativeIslandCode] = {
            title,
            day,
            toString() {
                return title;
            }
        };

        return acc;
    }, {});
};

export const DEFAULT_STATE = fromJS({
    data: {
        all: [],
        recent: [],
        popular: [],
        top10: [],
        top10Trending: [],
        codeNamesMap: {}
    },
    error: undefined,
    loading: false
});

export const games = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {timeScale, data, error} = action.payload || {};

    switch (action.type) {
        case gamesActions.TYPES.GET_GAMES: {
            return state.merge({
                timeScale,
                error: undefined,
                loading: true
            });
        }

        case gamesActions.TYPES.GET_GAMES_COMPLETE: {
            return state.merge({
                data: {
                    ...data,
                    error,
                    codeNamesMap: createMappings(data.all)
                },
                loading: false
            });
        }

        case gamesActions.TYPES.GET_GAMES_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('games', games);
